import { render, staticRenderFns } from "./favorite-other-items.vue?vue&type=template&id=32432115"
import script from "./favorite-other-items.vue?vue&type=script&lang=js"
export * from "./favorite-other-items.vue?vue&type=script&lang=js"
import style0 from "./favorite-other-items.vue?vue&type=style&index=0&id=32432115&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports